const SingleOccupancy = ({ height = "16", width = "16" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 640 512">
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      height={height}
      width={width}
      d="M32 320H256V176C256 149.5 277.5 128 304 128H528C589.9 128 640 178.1 640 240V464C640 472.8 632.8 480 624 480C615.2 480 608 472.8 608 464V416H32V464C32 472.8 24.84 480 16 480C7.164 480 0 472.8 0 464V48C0 39.16 7.164 32 16 32C24.84 32 32 39.16 32 48V320zM608 352H32V384H608V352zM528 160H304C295.2 160 288 167.2 288 176V320H608V240C608 195.8 572.2 160 528 160zM224 208C224 252.2 188.2 288 144 288C99.82 288 64 252.2 64 208C64 163.8 99.82 128 144 128C188.2 128 224 163.8 224 208zM144 160C117.5 160 96 181.5 96 208C96 234.5 117.5 256 144 256C170.5 256 192 234.5 192 208C192 181.5 170.5 160 144 160z"
    />
  </svg>
);

export default SingleOccupancy;
